import React from 'react';
import { FileText, Download, Trash2 } from 'lucide-react';
import clsx from 'clsx';
import Button from '@components/common/Button';
import type { EntityAttachment } from '@app-types/attachment';
import { formatFileSize, formatDate } from './helpers';
import styles from './AttachmentSection.module.css';

interface AttachmentListProps {
  attachments: EntityAttachment[];
  canManage: boolean;
  onDownload: (attachment: EntityAttachment) => void;
  onDelete: (attachment: EntityAttachment) => void;
}

const AttachmentList: React.FC<AttachmentListProps> = ({
  attachments,
  canManage,
  onDownload,
  onDelete,
}) => {
  if (attachments.length === 0) {
    return (
      <div className={styles.emptyState}>
        <FileText size={24} />
        <p>No files attached</p>
      </div>
    );
  }

  return (
    <div className={styles.filesList}>
      {attachments.map((attachment) => (
        <div key={attachment.id} className={styles.fileItem}>
          <FileText size={20} className={styles.fileIcon} />
          <div className={styles.fileInfo}>
            <div className={styles.fileName}>{attachment.originalName}</div>
            <div className={styles.fileMeta}>
              {formatFileSize(attachment.fileSize)}
              {' \u2022 '}
              {attachment.uploadedByPreferredName || attachment.uploadedByName || 'Unknown'}
              {' \u2022 '}
              {formatDate(attachment.createdAt)}
            </div>
          </div>
          <div className={styles.fileActions}>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDownload(attachment)}
              className={styles.actionButton}
            >
              <Download size={16} />
            </Button>
            {canManage && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onDelete(attachment)}
                className={clsx(styles.actionButton, styles.deleteButton)}
              >
                <Trash2 size={16} />
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AttachmentList;
